<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs>
        <v-layout row wrap justify-center align-center ma-0 pt-8 pa-0>
          <v-flex xs4 lg3 pa-2>
            <v-card class="rounded-lg">
              <v-card-title
                v-if="$vuetify.breakpoint.lgAndUp"
                primary-title
                class="white--text pa-2"
                style="background-color: #364780"
              >
                รายการความยินยอมทั้งหมด
              </v-card-title>
              <v-card-text
                class="pa-1 white--text"
                v-if="$vuetify.breakpoint.smAndDown"
                style="background-color: #364780; font-size: 14px"
              >
                รายการทั้งหมด
              </v-card-text>
              <v-card-text class="pa-4">
                {{ ItemCount.All }} รายการ
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs4 lg3 pa-2>
            <v-card class="rounded-lg">
              <v-card-title
                v-if="$vuetify.breakpoint.lgAndUp"
                primary-title
                class="white--text pa-2"
                style="background-color: #077893"
              >
                ให้ความยินยอม
              </v-card-title>
              <v-card-text
                class="pa-1 white--text"
                v-if="$vuetify.breakpoint.smAndDown"
                style="background-color: #077893; font-size: 14px"
              >
                ยินยอม
              </v-card-text>
              <v-card-text class="pa-4">
                {{ ItemCount.Approve }} รายการ
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs4 lg3 pa-2>
            <v-card class="rounded-lg">
              <v-card-title
                v-if="$vuetify.breakpoint.lgAndUp"
                primary-title
                class="white--text pa-2"
                style="background-color: #803636"
              >
                ปฏิเสธความยินยอม
              </v-card-title>
              <v-card-text
                class="pa-1 white--text"
                v-if="$vuetify.breakpoint.smAndDown"
                style="background-color: #803636; font-size: 14px"
              >
                ปฏิเสธ
              </v-card-text>
              <v-card-text class="pa-4">
                {{ ItemCount.UnApprove }} รายการ
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout
          row
          wrap
          justify-center
          align-center
          pa-0
          pt-3
          v-for="(item, index) in ItemConsent"
          :key="index"
        >
          <v-flex xs12 lg9 pa-2>
            <v-card class="rounded-lg">
              <v-card-title class="pa-3">
                <div v-if="_PathType == 'general'">
                  {{ item.ConsentHeader }}
                </div>
                <div v-else-if="_PathType == 'group'">
                  {{ item.GroupName }}
                </div>
              </v-card-title>
              <hr class="new4" />
              <!-- <v-progress-linear
                x-small
                color="green lighten-3"
                value="100"
              ></v-progress-linear> -->
              <v-card-text class="pa-4">
                <div v-if="_PathType == 'general'">
                  <p><b>หัวข้อนโยบาย</b> : {{ item.PolicyHeader }} ​</p>
                  <p><b>วันที่ให้ความยินยอม</b> : {{ item.SendAt }} ​</p>
                </div>
                <div v-else-if="_PathType == 'group'">
                  <p>
                    <b>จำนวนความยินยอม</b> :
                    <v-chip color="green lighten-5" small class="green--text">
                      {{ item.CountConsent }}
                    </v-chip>
                  </p>
                  <p><b>วันที่ให้ความยินยอม</b> : {{ item.SendAt }} ​</p>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  rounded
                  text
                  color="info"
                  @click="Fn_ViewDetail(item)"
                  class="mr-2"
                >
                  ดูรายละเอียด</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <br /><br />
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      Page: 1,
      ItemPerPage: 10,
      ItemConsent: [],
      ItemCount: [],
      number: [],
      AccessToken: "",
      DialogDelete: false,
      loadingDownloadData: false,
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),
    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    _PathType: {
      get() {
        return this.$route.path.split("/")[2] || "-";
      },
    },
    headersGeneral() {
      return [
        { text: "หมายเลขเอกสารความยินยอม", value: "SendId", sortable: false },
        { text: "ประเภท", value: "SourceSystem", sortable: false },
        {
          text: "หัวข้อความยินยอม",
          align: "left",
          value: "ConsentHeader",
          sortable: false,
        },
        { text: "หัวข้อนโยบาย", value: "PolicyHeader", sortable: false },
        {
          text: "องค์กร",
          value: "BusinessNameTh",
          sortable: false,
          align: "center",
        },
        { text: "วันที่ส่ง", value: "SendAt", sortable: false },
        { text: this.$i18n.t("consentlist.choice"), value: "action" },
      ];
    },
    headersGroup() {
      return [
        { text: "หมายเลขเอกสารความยินยอม", value: "SendId", sortable: false },
        { text: "ประเภท", value: "SourceSystem", sortable: false },
        {
          text: "หัวข้อกลุ่มความยินยอม",
          align: "left",
          value: "GroupName",
          sortable: false,
        },
        { text: "จำนวนความินยอม", value: "CountConsent", sortable: false },
        {
          text: "องค์กร",
          value: "BusinessNameTh",
          sortable: false,
          align: "center",
        },
        { text: "วันที่ส่ง", value: "SendAt", sortable: false },
        { text: this.$i18n.t("consentlist.choice"), value: "action" },
      ];
    },
  },
  mounted() {
    this.Fn_GetToken();
  },
  methods: {
    async Fn_GetToken() {
      this.loadingDownloadData = true;
      var payload = {
        ShareToken: this.$route.path.split("/")[4],
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/Redirect",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.AccessToken = response.data.Message.AccessToken;
            this.$cookies.set("ChatUsername", response.data.Message.Username);
            this.$cookies.set("ChatAccountId", response.data.Message.AccountId);
            this.Fn_getDataConsent();
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_getDataConsent() {
      this.loadingDownloadData = true;
      var SelectType = "";
      if (this.$route.path.split("/")[2] === "general") {
        SelectType = "General";
      } else if (this.$route.path.split("/")[2] === "group") {
        SelectType = "Group";
      }
      var payload = {
        AccountId: this.$route.path.split("/")[3],
        AccessToken: this.AccessToken,
        Type: SelectType,
      };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "onechat/History",
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsent = response.data.Message.Consent;
            this.ItemCount = response.data.Message.Count;
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.ItemConsent.length;
            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemConsent) {
              this.ItemConsent[j].no = number[j];
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_ViewDetail(href) {
      this.$store.dispatch("SET_DATA_CONSENT_ONECHAT", href);
      this.$store.dispatch("SET_DATA_CONSENT_ONECHAT_PATH", this.$route.path);
      if (this._PathType === "general") {
        this.$router.push("/onechat-general-history");
      } else if (this._PathType === "group") {
        this.$router.push("/onechat-group-history");
      }
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

hr.new4 {
  border: 1px solid #077893;
}
</style>
